import { gameArea } from "../utils/gameArea";
import VirtualControlPad, { padButtons } from "../managers/VirtualControlPad";
import GameScene, { GameModes } from "./GameScene";
import SoundManager from "../managers/SoundManager";
import MainMenuScene from "./MainMenuScene";

export enum PauseDeathModes {
    PAUSED = 0,
    WINNER = 1,
    LOSER = 2
};

export default class PauseDeathScene extends Phaser.Scene {
    titleText: Phaser.GameObjects.Text;
    goToGameText: Phaser.GameObjects.Text;
    exitText: Phaser.GameObjects.Text;
    graphics: Phaser.GameObjects.Graphics;
    currentMode: PauseDeathModes;

    constructor(){
        super({ key: 'PauseEndScene' });
    }

    create(){
        this.graphics = this.add.graphics();
        this.graphics.fillStyle(0x000000,0.85);
        this.graphics.fillRectShape(new Phaser.Geom.Rectangle(0,0, gameArea.screenWidth, gameArea.screenHeight));

        const tenth = gameArea.screenHeight/10;

        this.titleText = this.add.text(gameArea.screenWidth/2,tenth*4,"PAUSED.", { fontFamily: "Practice", fontSize: 120, stroke: '#000', strokeThickness: 3 });
        this.titleText.setOrigin(0.5);

        this.goToGameText = this.add.text(gameArea.screenWidth/8 * 3,tenth*6,"Continue.", { fontFamily: "Practice", fontSize: 40, stroke: '#000', strokeThickness: 3 });
        this.goToGameText.setOrigin(0.5);
        this.goToGameText.setInteractive();
        this.goToGameText.input.cursor = "pointer";
        this.goToGameText.on('pointerover', ()=>{
            SoundManager.playSfx('menuChange');
        });
        this.goToGameText.on('pointerdown', ()=>{ SoundManager.playSfx('menuSelect'); this.returnToGame(); });

        this.exitText = this.add.text(gameArea.screenWidth/8 * 5,tenth*6,"Quit to Menu.", { fontFamily: "Practice", fontSize: 40, stroke: '#000', strokeThickness: 3 });
        this.exitText.setOrigin(0.5);
        this.exitText.setInteractive();
        this.exitText.input.cursor = "pointer";
        this.exitText.on('pointerover', ()=>{
            SoundManager.playSfx('menuChange');
        });
        this.exitText.on('pointerdown', ()=>{ SoundManager.playSfx('menuSelect'); this.returnToMenu(); });

        this.setMode(PauseDeathModes.PAUSED);
    }

    returnToGame(){
        const gscene = <GameScene>this.scene.get('GameScene');
        this.scene.sleep();
        gscene.scene.bringToTop();
        gscene.scene.resume();
        switch(this.currentMode){
            case PauseDeathModes.PAUSED:
                gscene.setMode(GameModes.FIGHT);
            break;
            case PauseDeathModes.WINNER:
                gscene.currentArenaFight++;
            case PauseDeathModes.LOSER:
                gscene.resetGame();
                gscene.setMode(GameModes.COUNTIN);
            break;
        }
    }

    returnToMenu(){
        this.scene.sleep('HUDScene');
        this.scene.sleep();
        const gscene = <MainMenuScene>this.scene.get('MainMenuScene');
        gscene.scene.resume();
        gscene.scene.setVisible(true);
        gscene.scene.bringToTop();
        gscene.reinit();
    }

    update(time: number, delta: number){
        if(VirtualControlPad.isClicked(padButtons.START)){
            if(this.currentMode === PauseDeathModes.PAUSED)
                this.returnToGame();
            else
                this.returnToMenu();
        }
    }

    setMode(newMode: PauseDeathModes){
        //SoundManager.pauseAllMusic();
        switch(newMode){
            case PauseDeathModes.PAUSED:
                this.goToGameText.setVisible(true);
                this.titleText.setText("PAUSED.");
                this.goToGameText.setText("Continue.");
            break;
            case PauseDeathModes.WINNER:
                const gscene = <GameScene>this.scene.get('GameScene');
                if(gscene.currentArenaFight === gscene.fightList.length - 1){
                    this.titleText.setText("CHAMPION!");
                    this.goToGameText.setVisible(false);

                }else{
                    this.titleText.setText("VICTORIOUS.");
                    this.goToGameText.setVisible(true);
                    this.goToGameText.setText("Next Match.");
                }
            break;
            case PauseDeathModes.LOSER:
                this.titleText.setText("DEFEATED.");
                this.goToGameText.setVisible(true);
                this.goToGameText.setText("Retry Match.");
            break;
        }
        this.currentMode = newMode;
    }

}